class WardrobeSignup extends HTMLElement {
  connectedCallback() {
    if (this.ready) return;
    this.ready = true;
    const dialog = this.querySelector('dialog');
    const teaser = this.querySelector('[data-signup-open]');
    const key = 'wardrobe-newsletter-v1';
    const read = () => { try { return JSON.parse(localStorage.getItem(key) || '{}'); } catch { return {}; } };
    const save = value => { try { localStorage.setItem(key, JSON.stringify(value)); } catch {} };
    const subscribed = !!this.querySelector('[data-signup-success]');
    if (subscribed) save({ subscribed: true });
    const open = () => {
      if (document.querySelector('dialog[open]') || !this.isConnected) return;
      dialog.showModal();
      teaser.hidden = true;
    };
    const close = () => dialog.close();
    teaser.addEventListener('click', open);
    this.querySelectorAll('[data-signup-close]').forEach(button => button.addEventListener('click', close));
    dialog.addEventListener('click', event => { if (event.target === dialog) { const box = dialog.getBoundingClientRect(); if (event.clientX < box.left || event.clientX > box.right || event.clientY < box.top || event.clientY > box.bottom) close(); } });
    dialog.addEventListener('close', () => { if (!read().subscribed) { save({ dismissed: Date.now() }); teaser.hidden = false; } });
    if (subscribed || this.querySelector('[data-signup-error]')) { open(); return; }
    const state = read();
    if (state.subscribed || this.dataset.editor === 'true') return;
    teaser.hidden = false;
    if (state.dismissed && Date.now() - state.dismissed < 7 * 86400000) return;
    const timer = setTimeout(() => {
      if (matchMedia('(min-width: 750px)').matches && document.visibilityState === 'visible') open();
    }, 15000);
    this.addEventListener('disconnected', () => clearTimeout(timer), { once: true });
  }
}
if (!customElements.get('wardrobe-signup')) customElements.define('wardrobe-signup', WardrobeSignup);
